export function mountPortal(node, container = document.body) {
  const parent = node.parentNode;
  if (!parent) {
    return {
      unmount: () => {}
    };
  }
  const placeholder = document.createComment("rui-portal");
  parent.insertBefore(placeholder, node);
  container.appendChild(node);
  return {
    unmount: () => {
      const restoreParent = placeholder.parentNode;
      if (!restoreParent) {
        return;
      }
      restoreParent.insertBefore(node, placeholder);
      placeholder.remove();
    }
  };
}